// Deal utility functions for searching and sorting

import { Deal } from '../types';

// Helper function to safely convert a value to lowercase for searching
const safeToLower = (value: string | undefined | null): string => {
  return (value ?? '').toLowerCase();
};

// Helper function to search deals
export const searchDeals = (query: string, deals: Deal[]): Deal[] => {
  if (!query.trim()) {
    return deals;
  }

  const lowerQuery = query.toLowerCase();
  return deals.filter(
    deal =>
      safeToLower(deal.opportunityName).includes(lowerQuery) ||
      safeToLower(deal.dealRegistrationNumber).includes(lowerQuery) ||
      safeToLower(deal.opportunityNumber).includes(lowerQuery) ||
      safeToLower(deal.endUserCompanyName).includes(lowerQuery) ||
      safeToLower(deal.vertivRepresentativeName).includes(lowerQuery) ||
      safeToLower(deal.vertivRepresentativeEmail).includes(lowerQuery)
  );
};

// Helper function to sort deals
export const sortDeals = (
  deals: Deal[],
  sortBy: 'date' | 'name' | 'company' | 'regNumber',
  order: 'asc' | 'desc' = 'desc'
): Deal[] => {
  const sorted = [...deals].sort((a, b) => {
    let compareA: string;
    let compareB: string;

    switch (sortBy) {
      case 'date':
        compareA = a.opportunityCreatedDate;
        compareB = b.opportunityCreatedDate;
        break;
      case 'name':
        compareA = a.opportunityName.toLowerCase();
        compareB = b.opportunityName.toLowerCase();
        break;
      case 'company':
        compareA = a.endUserCompanyName.toLowerCase();
        compareB = b.endUserCompanyName.toLowerCase();
        break;
      case 'regNumber':
        compareA = a.dealRegistrationNumber;
        compareB = b.dealRegistrationNumber;
        break;
      default:
        return 0;
    }

    if (compareA < compareB) return order === 'asc' ? -1 : 1;
    if (compareA > compareB) return order === 'asc' ? 1 : -1;
    return 0;
  });

  return sorted;
};
